
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[locale]/collections/[collection_slug]",
      function () {
        return require("private-next-pages/[region]/[locale]/collections/[collection_slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[locale]/collections/[collection_slug]"])
      });
    }
  